module.exports = __webpack_public_path__ + "static/media/parallax-bg-7.fe77ad16.jpg";